<template>
  <div class="header--food-history-item">
    <router-link
      replace
      :to="{ name: 'FoodHistoryPage' }"
      class="header--food-history-item__back-link"
    >
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16 4L8 12L16 20" stroke="#151C22" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </router-link>
    <p class="header--food-history-item__text large-medium">Детали № 2312312</p>
    <div class="header--food-history-item__right-icon">
    </div>
  </div>
</template>

<script>
export default {
  name: "FoodHeaderView",
  mounted(){
    this.$store.dispatch('layout/setThemeColor', '#F6F6F6');
    this.$nextTick(() => {
      let headerHeight = this.$el.parentElement.offsetHeight
      this.$store.dispatch('layout/setHeaderHeight', headerHeight)
    })
  },

  updated(){
    this.$store.dispatch('layout/setThemeColor', '#F6F6F6');
    this.$nextTick(() => {
      let headerHeight = this.$el.parentElement.offsetHeight
      this.$store.dispatch('layout/setHeaderHeight', headerHeight)
    })
  }
}
</script>
<style lang="scss">
.header--food-history-item{
  display: flex;
  // justify-content: space-between;
  align-items: center;
  justify-content: space-between;
}
.header--food-history-item__back-link{
  display: flex; 
  align-items: center;
  font-weight: 600;
  font-size: 26px;
  line-height: 28px;
  margin: 0 12px 0 0;
  // overflow-wrap: anywhere;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  svg{
    flex-shrink: 0;
  }
}
.header--food-history-item__text{
  flex: 1 0 auto;
  color: #151C22;
  min-width: 0;
  text-align: center;
}
.header--food-history-item__right-icon{
  width: 24px;
  height: 24px;
}
</style>